import { ReactNode } from 'react';
import { Box, Button, Sheet, Spinner, Stack } from '@stitch-fix/mode-react';
import MenuButton from './MenuButton';
type MenuSheetProps = {
  children: ReactNode;
  count?: number;
  isResetDisabled: boolean;
  isViewResultsDisabled?: boolean;
  label: string;
  onClose: () => void;
  onResetClick: () => void;
  onViewResultsClick: () => void;
};

/**
 * The `MenuSheet` component implements mode-react's `Sheet` component to display
 * its children content when a `MenuButton` is clicked.
 */
const MenuSheet = ({
  children,
  count,
  isViewResultsDisabled,
  isResetDisabled,
  label,
  onClose,
  onViewResultsClick,
  onResetClick
}: MenuSheetProps) => {
  return <Sheet title={label} dismissiveAction={{
    label: 'Cancel'
  }} onClose={onClose} actionFooter={({
    handleClose
  }) => <Stack width={{
    md: 20.5
  }} spacing={0.75}>
          <Button variant="filled-statement" width="fill" onClick={() => {
      onViewResultsClick();
      handleClose();
    }} disabled={isViewResultsDisabled} endIcon={isViewResultsDisabled && <Spinner size="xsmall" />}>
            View results
          </Button>
          <Button variant="slim" width="fill" onClick={() => {
      onResetClick();
      handleClose();
    }} disabled={isResetDisabled}>
            Reset
          </Button>
        </Stack>} trigger={sheetProps => {
    return <MenuButton text={label} count={count} {...sheetProps} />;
  }}>
      <Box width={{
      md: 20.5
    }}>{children}</Box>
    </Sheet>;
};
export default MenuSheet;